<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('label.costItemClassificationCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled='isCodeDisabled' v-decorator="['itemValue', validatorRules.itemValue]" :placeholder="$t('label.pleaseEnterTheCostItemClassificationCode')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.costItemClassification')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['itemText', validatorRules.itemText]" placeholder="请输入费用项分类"></a-input> -->
            <mtc-lang-popover :whetherLang="whetherLang('itemText')" :popLists="getMainTablePop('itemText')">
                <a-input
                  v-decorator="['itemText', validatorRules.itemText]"
                  :read-only="whetherLang('itemText')"
                  @click="isLangClick('itemText', true)"
                  :placeholder="$t('label.pleaseEnterTheCostItemClassification')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.status')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <j-dict-select-tag type="list" v-decorator="['status',{'initialValue':'1'}]" :trigger-change="true" dictCode="qyjyzt" :placeholder="$t('label.pleaseSelectStatus')"  v-show=false />
            <a-switch checkedChildren="启用" unCheckedChildren="禁用" @change="onChose" v-model="visibleCheck"/>
            </a-form-item>
          </a-col>
         <!-- <a-col :span="24">
            <a-form-item label="成本项目" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag v-decorator="['ncCostItemCode']" dict="efs_stocking_cost_item,name,code" />
            </a-form-item>
          </a-col>-->
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <mtc-lang-modal/>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'


  export default {
    name: 'EfsFeeCategoryDictForm',
    mixins: [mtcLangModalMixin],
    components: {
      JFormContainer,
      JDictSelectTag,
      JSearchSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        mainTable: 'efs_fee_category_dict',
        isCodeDisabled: false,
        visibleCheck: true,
        // form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          itemText: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheCostItemClassification')},
            ]
          },
          itemValue: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheCostItemClassificationCode')},
              { validator: (rule, value, callback) => validateDuplicateValue('efs_fee_category_dict', 'item_value', value, this.model.id, callback)},
            ]
          },
        },
        url: {
          add: "/feeCategory/efsFeeCategoryDict/add",
          edit: "/feeCategory/efsFeeCategoryDict/edit",
          queryById: "/feeCategory/efsFeeCategoryDict/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    mounted() {
      this.form.resetFields({
        status: 1
      })
      this.visibleCheck=true
    },
    methods: {
      onChose(checked) {
        if (checked) {
          this.visibleCheck = true;
          this.form.setFieldsValue({
            status: 1
          })
        } else {
          this.visibleCheck = false;
          this.form.setFieldsValue({
            status: 0
          })
        }
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(this.model.id){
          this.isCodeDisabled=true
        }else{
          this.isCodeDisabled=false
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'itemText','itemValue','status','ncCostItemCode'))
          if(this.form.getFieldValue('status')==0){
            this.visibleCheck=false
          }else{
            this.visibleCheck=true
          }
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'itemText','itemValue','status','ncCostItemCode'))
        if(this.form.getFieldValue('status')==0){
          this.visibleCheck=false
        }else{
          this.visibleCheck=true
        }
      },
    }
  }
</script>